(() => {
  'use strict';

  function showError(wrapper, message) {
    const error = wrapper.querySelector('[data-zvg-error]');
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  }

  async function addItems(items, wrapper, button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const error = wrapper.querySelector('[data-zvg-error]');
    if (error) error.hidden = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || body.message || 'Could not add these items to the cart.');
      window.location.assign(`${window.Shopify.routes.root}cart`);
    } catch (errorMessage) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      showError(wrapper, errorMessage.message);
    }
  }

  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-zvg-quantity-change]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-zvg-atc]');
      const input = wrapper && wrapper.querySelector('[data-zvg-quantity]');
      if (!input) return;
      const delta = Number(quantityButton.dataset.zvgQuantityChange);
      input.value = Math.min(10, Math.max(1, Number(input.value || 1) + delta));
      return;
    }

    const vipButton = event.target.closest('[data-zvg-vip-add]');
    if (vipButton) {
      const wrapper = vipButton.closest('[data-zvg-atc]');
      const productVariant = Number(wrapper.dataset.productVariant);
      const membershipVariant = Number(wrapper.dataset.membershipVariant);
      const quantity = Number(wrapper.querySelector('[data-zvg-quantity]')?.value || 1);
      if (!productVariant || !membershipVariant) {
        showError(wrapper, 'The VIP product or current product variant is not configured.');
        return;
      }
      addItems([
        { id: productVariant, quantity },
        { id: membershipVariant, quantity: 1, properties: { 'Membership type': 'VIP membership' } },
      ], wrapper, vipButton);
    }
  });
})();
